import * as React from 'react';
import cx from 'classnames';
import aos from '@src/utils/aos';
import { observer } from 'mobx-react';
import Link from '@src/components/link';
const styles = require('./index.less');

const FollowUs = ({ store }) => {
  store.use();
  // const store = useStore(() => new FollowUsStore());
  return (
    <div className={styles.follow_us} {...aos.FADE_UP()}>
      <div className={styles.follow_us_list}>
        {store.qrcodeList.map((item, index) => (
          <div className={cx(styles.follow_us_item, item.link && styles.hasHover)} key={index} onClick={() => store.handleLink(item)}>
            <div className={styles.follow_us_qrcode}>
              <img src={item.img} alt={item.title} />
            </div>
            <img className={styles.follow_us_title} src={item.titleImg} alt={item.title} />
          </div>
        ))}
      </div>
      <Link className={styles.btn_version} onClick={store.showFooter} />
    </div>
  );
};

export default observer(FollowUs);
